var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import * as React from 'react';
import { useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { AdminPageSubpageContentContainer } from '../../AdminPage/AdminPageStyles';
import { Text, StackChildren, Spacing, Colors, Inset, } from '@doordash/design-language';
import styled from 'styled-components';
import { IMAGE_BASE_URL, PORTAL_ROUTE_PREFIX } from '../../../constants/values';
import OnboardingPageStrings from './OnboardingStrings';
import Checklist from './Checklist';
import { useMediaQuery } from '../../Common/MediaQueryProvider';
import { getSelectedTeamAccount, getSelectedTeamAccountContent, } from '../../../selectors/uiSelector';
import { useIsOnboardingFinished } from './useGetCompletedOnboardingStepsQuery';
import Loading from '@doordash/component-loading';
import { checkAllPageStepsCompleted, getChecklistItems, } from './utils';
import FinishOnboardingView from './FinishOnboardingView';
import { getSelectedTeamAccountPaymentInfo } from '../../../selectors/teamAccountPaymentInfoSelector';
import { TEAM_ACCOUNT_PAYMENT_METHOD } from '../../../types/portal_data';
import { EXPENSED_MEALS_STATUS } from '../../../types/expensed_meal';
import { WorkBenefit } from '../../../types/GloblalTypes';
var GUIDE_CONTAINER_HEIGHT = '500px';
var GUIDE_CONTAINER_HEIGHT_MOBILE = '1100px';
var GuideContainer = styled(Inset).attrs(function (props) { return ({
    size: props.isMobile ? Inset.Sizes.Medium : Inset.Sizes.XxLarge,
    isStretched: props.isMobile ? true : false,
}); })(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  background-color: ", ";\n  height: ", ";\n  display: flex;\n  justify-content: flex-start;\n  align-content: flex-start;\n  flex-direction: ", ";\n"], ["\n  background-color: ", ";\n  height: ",
    ";\n  display: flex;\n  justify-content: flex-start;\n  align-content: flex-start;\n  flex-direction: ",
    ";\n"])), Colors.SystemRed5, function (props) {
    return props.isMobile ? GUIDE_CONTAINER_HEIGHT_MOBILE : GUIDE_CONTAINER_HEIGHT;
}, function (props) {
    return props.isMobile ? 'column' : 'row';
});
var ONBOARDING_IMAGE_HEIGHT = '250px';
var GROUP_PEOPLE_IMG_URL = IMAGE_BASE_URL + "/s/managed/consumer/teams/self-serve-group-people.svg";
var DASHPASS_IMG_URL = IMAGE_BASE_URL + "/s/managed/consumer/teams/self-serve-dashpass.svg";
export var OnboardingImageContainer = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  background-image: url(", ");\n  background-size: ", ";\n  background-repeat: no-repeat;\n  background-position: center;\n  height: ", ";\n  width: 100%;\n"], ["\n  background-image: url(",
    ");\n  background-size: ",
    ";\n  background-repeat: no-repeat;\n  background-position: center;\n  height: ", ";\n  width: 100%;\n"])), function (props) {
    return props.workBenefit === WorkBenefit.WORK_BENEFIT_DASHPASS
        ? DASHPASS_IMG_URL
        : GROUP_PEOPLE_IMG_URL;
}, function (props) {
    return props.workBenefit === WorkBenefit.WORK_BENEFIT_DASHPASS
        ? '90%'
        : 'contain';
}, ONBOARDING_IMAGE_HEIGHT);
var TITLE_CONTAINER_MAX_WIDTH = '240px';
var TitleContainer = styled(StackChildren).attrs(function () { return ({
    size: StackChildren.Sizes.XSmall,
}); })(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  margin-right: ", "px;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: stretch;\n  max-width: ", ";\n"], ["\n  margin-right: ",
    "px;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: stretch;\n  max-width: ", ";\n"])), function (props) {
    return props.isMobile ? Spacing.None : Spacing.XxLarge;
}, TITLE_CONTAINER_MAX_WIDTH);
var PageTitleText = styled(Text).attrs(function (props) { return ({
    color: Text.Colors.TextPrimary,
    styles: props.isMobile ? Text.Styles.Title1 : Text.Styles.PageTitle2,
}); })(templateObject_4 || (templateObject_4 = __makeTemplateObject([""], [""])));
var LoadingViewContainer = styled.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: stretch;\n"], ["\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: stretch;\n"])));
var showLoadingView = function () { return (React.createElement(LoadingViewContainer, null,
    React.createElement(Loading, { size: Loading.Sizes.Medium, color: Loading.Colors.SystemGrey30 }))); };
var OnboardingContainer = function () {
    var _a, _b;
    var isMobile = useMediaQuery().isMobile;
    var history = useHistory();
    var teamAccountId = useSelector(getSelectedTeamAccount);
    var teamAccount = useSelector(getSelectedTeamAccountContent);
    // If EM is inactive, we are onboarding DP
    // This is because EM is active right away when onboarding EM
    var isOnboardingDashPass = ((_a = teamAccount === null || teamAccount === void 0 ? void 0 : teamAccount.expensedMeals) === null || _a === void 0 ? void 0 : _a.status) === EXPENSED_MEALS_STATUS.INACTIVE;
    var workBenefit = isOnboardingDashPass
        ? WorkBenefit.WORK_BENEFIT_DASHPASS
        : WorkBenefit.WORK_BENEFIT_EXPENSED_MEALS;
    var selectedTeamAccountPaymentInfo = useSelector(getSelectedTeamAccountPaymentInfo);
    var paymentMethod = (_b = selectedTeamAccountPaymentInfo === null || selectedTeamAccountPaymentInfo === void 0 ? void 0 : selectedTeamAccountPaymentInfo.paymentMethod) !== null && _b !== void 0 ? _b : TEAM_ACCOUNT_PAYMENT_METHOD.UNKNOWN;
    var isExpensedMealInvoicing = paymentMethod === TEAM_ACCOUNT_PAYMENT_METHOD.INVOICING;
    var _c = useIsOnboardingFinished(teamAccountId), isOnboardingFinished = _c.isOnboardingFinished, isLoadingStep = _c.loading, completedSteps = _c.completedSteps;
    var isAllPageStepCompleted = checkAllPageStepsCompleted(completedSteps, workBenefit);
    var checklistItems = getChecklistItems(completedSteps, isExpensedMealInvoicing, workBenefit);
    var pageTitleForIncompleteOnboarding = isOnboardingDashPass
        ? OnboardingPageStrings.dashPass.pageTitle()
        : OnboardingPageStrings.expensedMeals.pageTitle();
    var pageTitleForCompleteOnboarding = isOnboardingDashPass
        ? OnboardingPageStrings.dashPass.pageTitleForFinishOnboarding()
        : OnboardingPageStrings.expensedMeals.pageTitleForFinishOnboarding();
    var pageTitle = !isAllPageStepCompleted
        ? pageTitleForIncompleteOnboarding
        : pageTitleForCompleteOnboarding;
    if (isOnboardingFinished) {
        history.push(PORTAL_ROUTE_PREFIX + "/admin");
        return null;
    }
    var getLoadedView = function () {
        if (!isAllPageStepCompleted) {
            return React.createElement(Checklist, { checklistItems: checklistItems });
        }
        return (React.createElement(FinishOnboardingView, { checklistItems: checklistItems, workBenefit: workBenefit }));
    };
    return (React.createElement(AdminPageSubpageContentContainer, null,
        React.createElement(GuideContainer, { isMobile: isMobile },
            React.createElement(TitleContainer, { isMobile: isMobile },
                React.createElement(PageTitleText, null, pageTitle),
                React.createElement(OnboardingImageContainer, { workBenefit: workBenefit })),
            isLoadingStep ? showLoadingView() : getLoadedView())));
};
export default OnboardingContainer;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;
